import { ScrollView, View } from 'react-native'
import { Portal } from 'react-native-paper'

import Logo from '@/components/navigation/Logo'
import UniButton from '@/components/unistyles/UniButton'
import UniModal from '@/components/unistyles/UniModal'
import UniText from '@/components/unistyles/UniText'
import useModalStyles from '@/hooks/useModalStyles'

interface PushNotificationModalProps {
  visible: boolean
  onAllow: () => void
  onSkip: () => void
  onDismiss?: () => void
}

const PushNotificationModal = ({
  visible,
  onAllow,
  onSkip,
  onDismiss,
}: PushNotificationModalProps) => {
  const { styles, getModalProps } = useModalStyles()

  return (
    <Portal>
      <UniModal
        onDismiss={onDismiss || onSkip}
        style={styles.modal}
        testID="push-notification-modal"
        visible={visible}
      >
        <View style={styles.card}>
          <Logo style={styles.logo} />
          <ScrollView {...getModalProps()}>
            <UniText style={styles.title} variant="titleLarge">
              Stay Informed
            </UniText>
            <UniText style={styles.body} variant="bodyMedium">
              We use push notifications to remind you about foster health needs,
              medication schedules, and important updates. You can always change
              this later in your settings.
            </UniText>
          </ScrollView>
          <UniButton
            contentStyle={styles.buttonContent}
            mode="contained"
            onPress={onAllow}
            style={styles.primaryButton}
            testID="push-notification-modal-allow-button"
          >
            Allow Notifications
          </UniButton>
          <UniButton
            contentStyle={styles.buttonContent}
            mode="text"
            onPress={onSkip}
            style={styles.textButton}
            testID="push-notification-modal-skip-button"
          >
            Skip
          </UniButton>
        </View>
      </UniModal>
    </Portal>
  )
}

export default PushNotificationModal
